import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import * as Colors from '../../../theme/colors';
import FormPageHeaderBase from './FormPageHeaderBase';
import { FormPageHeaderProps } from '../formPageTypes';
import { RootState } from '../../../store/reduxTypes';
import { RIGHT_SIDEBAR_WIDTH } from '../../../constants';
import { drawerWidth } from '../../Sidebar/DrawerSection';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageAction: (props: BorderFormPageHeaderProps) => ({
      border: 'none',
      ...(props.borderPosition === 'top'
        ? { borderTop: `1px solid ${Colors.DividersAndCardBorders}` }
        : { borderBottom: `1px solid ${Colors.DividersAndCardBorders}` }),
      borderRadius: 0,
    }),
    condensed: {
      [theme.breakpoints.up('lg')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        paddingRight: `${RIGHT_SIDEBAR_WIDTH + theme.spacing(4.5)}px`,
      },
    },
  }),
);
interface BorderFormPageHeaderProps {
  borderPosition: 'top' | 'bottom';
}
const BorderFormPageHeader: React.FC<BorderFormPageHeaderProps &
  FormPageHeaderProps> = ({ borderPosition, ...rest }) => {
  const classes = useStyles({ borderPosition });
  const formCreatePanelData = useSelector(
    (state: RootState) => state.intakeForms.formCreatePanel.data,
  );

  return (
    <FormPageHeaderBase
      {...rest}
      className={classNames(classes.pageAction, {
        [classes.condensed]: Boolean(formCreatePanelData),
      })}
    />
  );
};

export default BorderFormPageHeader;
